import type { AgentModuleConfig } from '@/context/agent-container.context';
import { useNamiEnabled } from '@/components/nami/useNamiEnabled';

/**
 * Whether the shared agent panel may show: the Nami copilot is on (chat agent
 * or copilot flag), or the registered module exposes the panel under its own
 * feature flag.
 */
export function useAgentPanelEnabled(
  moduleConfig: Pick<AgentModuleConfig, 'forcePanelEnabled'> | null,
): boolean {
  const namiEnabled = useNamiEnabled();
  return namiEnabled || moduleConfig?.forcePanelEnabled === true;
}
